






import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class Music extends Vue {
  @Prop(Boolean) mini!: boolean;

  get isPlay() {
    return this.$store.state.isPlay;
  }

  @Emit('click')
  handleClick() {
    this.toggleMute();
  }

  toggleMute() {
    const audios = this.$store.state.audios;
    // this.isPlay = !this.isPlay;

    for (const key in audios) {
      if (audios.hasOwnProperty.call(audios, key)) {
        const audio = audios[key];
        audio.muted = this.isPlay;
        console.log(this.isPlay);
      }
    }
    this.$store.dispatch('update', { key: 'isPlay', data: !this.isPlay });
  }
}
